var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconApply({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.127 4.09961C12.8535 3.85352 12.4434 3.85352 12.1973 4.09961L5.25195 11.0996L1.75195 7.59961C1.50586 7.35352 1.0957 7.35352 0.849609 7.59961C0.576172 7.87305 0.576172 8.2832 0.849609 8.5293L4.78711 12.4668C4.89648 12.6035 5.06055 12.6582 5.25195 12.6582C5.41602 12.6582 5.58008 12.6035 5.68945 12.4668L13.127 5.0293C13.4004 4.7832 13.4004 4.37305 13.127 4.09961ZM4.78711 6.3418C4.89648 6.47852 5.06055 6.5332 5.25195 6.5332C5.41602 6.5332 5.58008 6.47852 5.68945 6.3418L10.502 1.5293C10.7754 1.2832 10.7754 0.873047 10.502 0.626953C10.2559 0.353516 9.8457 0.353516 9.59961 0.626953L5.25195 4.97461L3.06445 2.78711C2.79102 2.54102 2.38086 2.54102 2.13477 2.78711C1.86133 3.06055 1.86133 3.4707 2.13477 3.7168L4.78711 6.3418Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApply);
export default __webpack_public_path__ + "static/media/icon-apply.83a82f26551b0f5cbd584791e6fed9ea.svg";
export { ForwardRef as ReactComponent };